import { render, staticRenderFns } from "./UITextField.vue?vue&type=template&id=3544bb4c&scoped=true"
import script from "./UITextField.vue?vue&type=script&lang=js"
export * from "./UITextField.vue?vue&type=script&lang=js"
import style0 from "./UITextField.vue?vue&type=style&index=0&id=3544bb4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3544bb4c",
  null
  
)

export default component.exports